import React from "react";
import { Link, useLocation } from "react-router-dom";

function Breadcrumb() {
  const location = useLocation(); // Get current location (path) from react-router

  // Split the pathname into segments and filter out empty segments
  const pathSegments = location.pathname.split('/').filter(segment => segment);

  return (
    <nav className="breadcrumb-container">
      <ul className="breadcrumb">
        <li>
          <Link to="/">Home /</Link> {/* Link to the homepage */}
        </li>
        {/* Dynamically display the breadcrumb segments */}
        {pathSegments.map((segment, index) => (
          <React.Fragment key={index}>
            <li>
              {/* Add a link for each part of the breadcrumb, except the last segment */}
              {index < pathSegments.length - 1 ? (
                <Link to={`/${pathSegments.slice(0, index + 1).join('/')}`}>
                  {segment} /
                </Link>
              ) : (
                <span>{segment}</span> // Last segment, display as text
              )}
            </li>
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
}

export default Breadcrumb;
